import { queryOptions, useQuery, type UseQueryResult } from "@tanstack/react-query";
import { taskKeys } from "@/domains/tasks/api/keys";
import type { CameraTask, TaskTemplate } from "@/domains/tasks/api/types";
import {
  fetchTaskTemplates,
  fetchTasks,
  fetchTasksByAssignee,
  fetchTasksByCase,
} from "@/domains/tasks/mocks/tasksService";

export const tasksListOptions = queryOptions({
  queryKey: taskKeys.lists(),
  queryFn: fetchTasks,
});

export const tasksByCaseOptions = (caseId: string) =>
  queryOptions({
    queryKey: taskKeys.byCase(caseId),
    queryFn: () => fetchTasksByCase(caseId),
  });

export const tasksByAssigneeOptions = (userId: string) =>
  queryOptions({
    queryKey: taskKeys.byAssignee(userId),
    queryFn: () => fetchTasksByAssignee(userId),
  });

export const taskTemplatesOptions = queryOptions({
  queryKey: taskKeys.templates(),
  queryFn: fetchTaskTemplates,
});

export function useTasks(): UseQueryResult<ReadonlyArray<CameraTask>> {
  return useQuery(tasksListOptions);
}

export function useTasksByCase(caseId: string): UseQueryResult<ReadonlyArray<CameraTask>> {
  return useQuery(tasksByCaseOptions(caseId));
}

export function useTasksByAssignee(userId: string): UseQueryResult<ReadonlyArray<CameraTask>> {
  return useQuery(tasksByAssigneeOptions(userId));
}

export function useTaskTemplates(): UseQueryResult<ReadonlyArray<TaskTemplate>> {
  return useQuery(taskTemplatesOptions);
}
